
<template>   
    <div class="row"  v-if="model">  
        <div class="col-12 col-sm-12 col-md-12 col-xl-12"> <br> 
            <CardRh :processando="processando" :titulo="'Falta do dia '+ formatData(model.aula.data)" >  
                <div class="row g-6 g-xl-12 mt-5"   >  
                    <div class="row">  
                        <div class="col-12  col-xxl-6 ">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-graduation-cap fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Disciplina</span>
                                    <span class="fs-7">{{ model.disciplina.descricao  }} </span>
                                </span> 
                            </button>
                        </div> 
                        <div class="col-12  col-xxl-6 ">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-sitemap fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Observação do Controlador</span>
                                    <span class="fs-7">{{ model.observacao  }} </span>
                                </span> 
                            </button>
                        </div>  
                        <div class="col-12">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-sitemap fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Observação STE</span>
                                    <span class="fs-7">{{ model.observacaoste  }} </span>
                                </span> 
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-user fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Aluno</span>
                                    <span class="fs-7">{{ model.matricula.usuario.nome  }} </span>
                                </span> 
                            </button>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-clock fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Início</span>
                                    <span class="fs-7">{{ model.aula.inicio  }} </span>
                                </span> 
                            </button>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-clock fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Fim</span>
                                    <span class="fs-7">{{ model.aula.fim  }} </span>
                                </span> 
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-bullseye fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Motivo</span>
                                    <span class="fs-7">{{ model.faltaMotivo.nome  }} </span>
                                </span> 
                            </button>
                        </div>   
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-layer-group fa-2x bi fs-2x" ></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Pelotão</span>
                                    <span class="fs-7">{{ model.matricula.pelotao  }} </span>
                                </span> 
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-map-pin fa-2x bi fs-2x" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Número da Aula</span>
                                    <span class="fs-7">{{ model.aula.numero   }} </span>
                                </span> 
                            </button>
                        </div>  
 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-award bi fs-2x" v-if="model.faltaTipo.id === 1"></i>  
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Classificação</span>
                                    <span class="fs-7"  v-if="model.faltaTipo.id === 1"> Indefinido</span> 
                                    <span class="fs-7"  v-if="model.faltaTipo.id === 2"> Amparado</span> 
                                    <span class="fs-7"  v-if="model.faltaTipo.id === 3"> Não Amparado</span> 
                                </span> 
                            </button>
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-spinner bi fs-2x" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Status</span>
                                    <span class="fs-7"  v-if="model.status.id === 1"> AGUARDANDO HOMOLOGAÇÃO</span> 
                                    <span class="fs-7"  v-if="model.status.id === 2"> AGUARDANDO CLASSIFICAÇÃO</span> 
                                    <span class="fs-7"  v-if="model.status.id === 3"> ARQUIVADA</span> 
                                </span> 
                            </button>
                        </div> 
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 text-center">
                            <button class="btn btn-flex btn-secondary px-6 btn-flex-full  pulse pulse-primary"> 
                                <span class="menu-icon ">
                                    <i class="fas fa-spinner bi fs-2x" ></i> 
                                </span>
                                <span class="d-flex flex-column align-items-start ms-2">
                                    <span class="fs-3 fw-bolder">Situação</span>
                                    <span class="fs-7"> {{ model.situacao.nome.replaceAll("_", " ") }}</span>  
                                </span> 
                            </button>
                        </div> 
                        <div class="col-12 text-center" v-if="hasPermissaoEditar && model.status.id === 1"> <br>
                            <button @click="homologar" type="button" class="btn btn-pmes-secondary me-10 float-right"  :data-kt-indicator=" processando ? 'on' : 'off'">
                                <span class="indicator-label">
                                <i class="fa fa-save"></i> Homologar  
                                </span>
                                <span class="indicator-progress">
                                        Processando  
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>  
                        </div>     
                    </div>   
                </div>  
                <template v-slot:action>  
                    <button class="btn btn-sm btn-light me-2" @click="editar" v-if="hasPermissaoEditar">  
                        <span class="menu-icon">
                            <i class="fas fa-edit fa-2x bi fs-2x text-pmes-primary" ></i> 
                        </span>
                        Editar
                    </button>   
                </template>    
            </CardRh>  
        </div>  
        
        <!-- <div class="col-12 col-sm-12 col-md-12 col-xl-4"> <br>  
            <div class="row">   
                <div class="col-12" v-if="model.is_aguardando_classificacao"> 
                    <div class="form-group"> 
                        <label for="descricao" class="form-check-label">Tipo de Amparo:</label> 
                        <Multiselect v-model="falta_tipo_id" :options="tipos_select" :searchable="true"></Multiselect> 
                    </div> 
                </div> 
                <div class="col-12" v-if="model.is_aguardando_classificacao"> 
                    <BotaoSalvar  @click="classificar" :processando="processando" titulo="Classificar" ></BotaoSalvar>   
                </div>  
                <div class="col-12"> 
                    <h3 class="text-center">Historico</h3> <br>
                </div>
                <div class="col-12"> 
                    <div v-for="p in model.situacoes" :key="p.id" class="me-5">  
                        <div class=" alert alert-dismissible bg-light-primary border border-primary border-2 border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10 position-relative me-5  " >
                            <span class="svg-icon svg-icon-2hx svg-icon-primary me-4 mb-5 mb-sm-0" > 
                                <i class="fas fa-plus bi fs-2x" v-if="p.falta_status_atual === 1"></i>
                                <i class="fas fa-user-clock  bi fs-2x" v-if="p.falta_status_atual === 2"></i>
                                <i class="fas fa-inbox bi fs-2x" v-if="p.falta_status_atual === 3"></i>
                                <i class="fas fa-trash-alt bi fs-2x" v-if="p.falta_status_atual === 4"></i> 
                            </span>  
                            <div class="d-flex flex-column pe-0 pe-sm-10 " >
                                <h5 class="mb-1"> {{p.status_atual}}</h5>
                                <span> Classificação: {{p.tipo_falta}}</span> 
                            </div> 
                            <span class="position-absolute top-0 start-100 translate-middle  badge  badge-danger">{{ p.created_at }}</span>
                            <span class="position-absolute top-100 start-100 translate-middle  badge  badge-secondary">{{p.updated_user}}</span>
                        </div> 
                    </div>
                    <div>
                        <i class="fas fa-clock bg-gray fs-2x"></i>
                    </div>  
                </div> 
            </div> 
        </div>    -->

    </div> 
</template>

<script lang="ts">   
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import Multiselect from '@vueform/multiselect' 
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import FaltaService from "@/service/v1/sigap/FaltaService"

    @Options({
        name: "MatriculaShow",
        components: {  CardRh , KDataTable , Multiselect , BotaoSalvar },   
        emits: [  'falta-classidicada'], 
    }) 
    export default class MatriculaShow extends Vue {
          
        @authStore.Getter
        public perfis!: any

        public service = new FaltaService(); 
          
        public model: any = null ;
        public falta_tipo_id: any = null ;
        public processando = false ;
        public formulario: any  = null ;   
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get tipos_select(){ 
            return [ 
                { value: 1, label: 'INDEFINIDO' } ,
                { value: 2, label: 'AMPARADO' } ,
                { value: 3, label: 'SEM AMPARADO' } ,
            ]; 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        public formatData( data ): string {
            return SiteUtils.formatData( data );
        }

        created(){
            this.buscaFalta(); 
        }

        public statusAlterado(dados){ 
            this.buscaFalta() ;
        }

        public buscaFalta(){   
            this.processando = true ;  
            this.service.getModel( this.$route.params.id) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.falta_tipo_id =  this.model.falta_tipo_id ;  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        } 

        public editar(   ) {   
            this.$router.push({name: 'sigap_falta_editar',  params: {  id: this.$route.params.id  } });
        }  

        public classificar(){   
            this.processando = true ; 
            if(this.falta_tipo_id ){
                let dados = {
                    falta_tipo_id: this.falta_tipo_id  
                }
                // this.service.classificar( this.model.id , dados ) 
                // .then(response => {   
                //     this.model = null ;
                //     this.buscaFalta();  
                //     this.$emit("falta-classidicada", null);   
                //     this.processando = false ;    
                // })
                // .catch(error => { 
                //     this.processando = false ; 
                // }); 
            } 
        } 
 
        public homologar(){   
            this.processando = true ;  
            // this.service.homologar( this.model.id   ) 
            // .then(response => {   
            //     this.buscaFalta();  
            //     this.$emit("falta-classidicada", null);   
            //     this.processando = false ;    
            // })
            // .catch(error => { 
            //     this.processando = false ; 
            // });  
        } 
   
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    } 
    .start-90{
        left: 97% !important;
    } 
    .col-12{
        margin-bottom: 40px;
    } 
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    }
    .col-12{
        margin-bottom: 25px;
    } 
</style>